<template>
    <div class="relative">
        <TextInput
            :id="id"
            :label="label"
            :error="error"
            :type="showPasswordText ? 'text' : 'password'"
            :inputClasses="[inputClasses, 'pr-9']"
            :modelValue="modelValue"
            @input="$emit('update:modelValue', $event.target.value)"
            :required="required"
            autocomplete="current-password"
            ref="passwordInput"
            :description="description"
        >
            <template v-slot:absolute>
                <button
                    @click.stop="showPasswordText = !showPasswordText"
                    type="button"
                    class="w-7 absolute right-2 top-1/2 -translate-y-1/2 text-text-secondary hover:text-gray-800"
                >
                    <transition name="fade" mode="out-in">
                        <PhEyeSlash v-if="showPasswordText" class="w-full" />
                        <PhEye v-else class="w-full" />
                    </transition>
                </button>
            </template>
        </TextInput>
    </div>
</template>

<script>
import TextInput from '@/Components/FormElements/TextInput.vue'
import { PhEye, PhEyeSlash } from '@phosphor-icons/vue'
export default {
    name: 'PasswordInput',

    emits: ['update:modelValue'],

    expose: ['focusMethod'],

    props: {
        modelValue: {
            type: String,
            required: true,
        },
        id: {
            type: String,
            required: true,
        },
        inputClasses: {
            type: String,
            required: false,
        },
        error: {
            type: String,
            default: null,
        },
        label: {
            type: String,
            default: null,
        },
        description: {
            type: String,
            default: null,
        },
        required: {
            type: Boolean,
            default: false,
        },
    },

    components: {
        PhEye,
        PhEyeSlash,
        TextInput,
    },

    data() {
        return {
            showPasswordText: false,
        }
    },

    methods: {
        focusMethod() {
            this.$refs.passwordInput.focusMethod()
        },
    },
}
</script>
